export const endpoints = {
  importSetItem: 'importSet',
  duplicateImportSet: (id: number) => `importSet/${id}:duplicate`,
  languageOptions: 'importSet/language/options',
  criteriaDomainOptions: 'importSet/criteriaDomain/options',
  importConstraintSetOptions: 'importSet/constraintSet/options'
};
